<div class="bn-auth">
  <router-outlet />
</div>
